import {
  QueryParamError,
  QueryParamErrorLevel,
} from '../../lib/validateQueryParams';

interface Props {
  // any query param errors on the redirect url, such as missing tracking parameters, duplicated query params, invalid query params, or deprecated params
  queryParamErrors: Map<string, QueryParamError>;
}

// displays a error message on the interstitial page when the redirect is suppressed (non-prod environments only)
const QueryParamErrorComponent: React.FC<Props> = ({ queryParamErrors }) => {
  const errors = Array.from(queryParamErrors.entries()).filter(
    ([, error]) => error.level === QueryParamErrorLevel.ERROR
  );
  const warnings = Array.from(queryParamErrors.entries()).filter(
    ([, error]) => error.level === QueryParamErrorLevel.WARN
  );

  return (
    <>
      {queryParamErrors.size > 0 && (
        <div>
          <p style={{ textDecoration: 'underline', color: 'black' }}>
            Append the `suppress` query parameter to stay on this page and view
            the following error.
            <br />
            This message should only be displayed in stage. Note that
            interstitial client will still send the Segment shopping finished
            event when query param validation fails, as long as the configured
            destination URL is valid. There is no validation performed in prod.
          </p>
          <br />
          <div style={{ overflow: 'auto', maxHeight: '200px' }}>
            {errors.length > 0 && (
              <div>
                <b style={{ fontSize: '18px' }}>ERRORS</b>
                <br />
                {errors.map(([key, error]) => (
                  <span key={key}>
                    <b>{key}</b>: {error.message}
                    <br />
                  </span>
                ))}
                <br />
              </div>
            )}
            {warnings.length > 0 && (
              <div>
                <b style={{ fontSize: '18px' }}>WARNINGS</b>
                <br />
                {warnings.map(([key, error]) => (
                  <span key={key}>
                    <b>{key}</b>: {error.message}
                    <br />
                  </span>
                ))}
              </div>
            )}
          </div>
          <br />
          <div>
            <p>
              Click&nbsp;
              <a href="https://github.com/NerdWallet/interstitial-client-next/blob/main/app/server/lib/types/request.ts#L5-L16">
                here
              </a>
              &nbsp;for more information.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default QueryParamErrorComponent;
